module.exports = __webpack_public_path__ + "static/media/tour-time-green.50f32a69.svg";